import * as React from 'react';
import { IconProps } from '../types';

const IcShow = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g fill={props.fill ?? '#232F3E'} fillRule="evenodd" clipPath="url(#a)" clipRule="evenodd">
      <path d="M12.5 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm0 1.5a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" />
      <path d="M5.568 6.725C7.485 5.351 9.865 4.25 12.5 4.25c2.655 0 4.979 1.117 6.813 2.511a17.6 17.6 0 0 1 4.043 4.378c.327.514.348 1.17.042 1.705C21.95 15.37 18.145 19.75 12.5 19.75c-5.595 0-9.675-4.308-11.313-6.825a1.65 1.65 0 0 1 .043-1.862 19.497 19.497 0 0 1 4.338-4.338Zm.874 1.22a18 18 0 0 0-3.991 3.99.15.15 0 0 0-.006.172C3.983 14.473 7.67 18.25 12.5 18.25c4.843 0 8.252-3.806 9.596-6.152a.147.147 0 0 0-.006-.153 16.104 16.104 0 0 0-3.684-3.99C16.736 6.687 14.724 5.75 12.5 5.75c-2.215 0-4.293.929-6.058 2.194Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.5 0h24v24H.5z" />
      </clipPath>
    </defs>
  </svg>
);

export default IcShow;
